























import { Vue, Component } from "vue-property-decorator";
import { getUsers } from "@/store/api";
import UserModel from "@/store/models/UserModel";
import searchbox from "@/store/modules/searchbox";

@Component
export default class Header extends Vue {
  searchValue = "";
  users: Array<UserModel> = [];
  selectedUser: UserModel | null = null;

  get homeUrl() {
    if (this.$route.path === "/") return true;
    return false;
  }

  async created() {
    this.users = await getUsers();
  }

  selectUser(user: UserModel) {
    this.selectedUser = user;
    searchbox.updateUser(user);
    this.searchValue = "";
  }

  removeUser() {
    this.selectedUser = null;
    searchbox.updateUser(null);
  }

  get filteredUsers() {
    const matchedUsers: Array<UserModel> = [];
    const searchVal = this.searchValue.toLowerCase();

    if (searchVal.trim().length < 2) return matchedUsers;
    this.users.forEach(user => {
      if (
        (user.first_name.toLowerCase().includes(searchVal) || user.last_name.toLowerCase().includes(searchVal)) &&
        user.job_title
      )
        matchedUsers.push(user);
    });
    return matchedUsers;
  }
}
